<template>
  <yxt-select
    v-model="selectCatalog"
    :placeholder="$t(placeholder)"
    :multiple="multiple"
    :clearable="clearable"
    :size="size"
    :filterable="filterable"
    :loading="cateLoading"
    :no-data-text="$t('pc_biz_shoptour_no_data', /* 暂无数据 */)"
    popper-class="max-w400"
    @change="onCatalogChange"
    @visible-change="selectIsOpen = $event"
  >
    <div
      v-infinite-scroll="loadMore"
      :infinite-scroll-immediate="false"
      :infinite-scroll-delay="500"
      :infinite-scroll-disabled="!selectIsOpen || finished"
    >
      <yxt-tooltip
        v-for="item in catalogList"
        :key="item.id"
        class="item"
        effect="dark"
        :open-filter="true"
        :content="item.storeCatName"
        :max-width="300"
        placement="top"
      >
        <yxt-option
          :label="item.storeCatName"
          :value="item.id"
        />
      </yxt-tooltip>
    </div>
    <div
      v-if="loading"
      class="text-align-center"
    >
      <i class="yxt-icon-loading color-primary-6" />
    </div>
  </yxt-select>
</template>

<script>
import { getCateList } from '../service';
// 新增分类组件
export default {
  name: 'ShopClassifySelector',
  props: {
    placeholder: {
      type: String,
      default: 'pc_biz_shoptour_select_catalog_tip' /* 请选择分类 */
    },
    multiple: { // 是否多选
      type: Boolean,
      default: false
    },
    clearable: { // 是否可清空
      type: Boolean,
      default: false
    },
    size: { // 搜索框尺寸
      type: String,
      default: ''
    },
    filterable: { // 是否可搜索
      type: Boolean,
      default: false
    },
    cateIds: { // 已选择分类id组
      type: Array,
      default: function() {
        return [];
      }
    }
  },
  data() {
    return {
      loading: false, // 加载中
      finished: false, // 加载结束，没有更多了
      catalogList: [], // 分类列表
      selectCatalog: '', // 选中的分类
      query: { // 搜索参数
        limit: 200,
        offset: 0,
        total: 0,
        searchKey: ''
      },
      selectIsOpen: false, // 下拉框是否是显示状态
      cateLoading: false // 分类加载
    };
  },
  watch: {
    cateIds(newVal) {
      if (this.multiple && newVal) {
        this.selectCatalog = [...this.cateIds];
      }
    }
  },
  mounted() {
    if (this.multiple) {
      this.selectCatalog = [...this.cateIds];
    }
    this.getData();
  },
  methods: {
    // 分类选中之后
    onCatalogChange(value) {
      this.$emit('change', value);
    },
    // 滚动加载
    loadMore() {
      if (!this.loading && !this.finished) {
        this.getData();
      }
    },
    // 获取分类列表
    getData() {
      this.loading = true;
      const { limit, offset } = this.query;
      const params = {
        limit,
        offset
      };
      getCateList(params).then(res => {
        this.catalogList = this.catalogList.concat(res.datas);
        this.query.offset = res.paging.offset + this.query.limit;
        this.query.total = res.paging.count;
        this.finished = this.query.offset >= this.query.total;
        if (!this.finished) {
          this.getData();
        }
      }).finally(() => {
        this.loading = false;
      });
    }
  }
};
</script>
